import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AT = {
    SetObjectOverlaysDisabled: 'objectOverlaysDisabled/SetObjectOverlaysDisabled',
};
export const ObjectOverlaysDisabledState = {
    actions: {
        setObjectOverlaysDisabled: (disabled) => action(AT.SetObjectOverlaysDisabled, disabled),
    },
    actionTypes: AT,
    reducer: createReducer(false, {
        [AT.SetObjectOverlaysDisabled]: (_state, action) => {
            return action.payload;
        },
    }),
};
